// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_CancelEmployeeAdvanceInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /payroll/cancel_employee_advance/{id}
 *
 * Cancels an employee advance. No body required — id is a URL path parameter.
 */
import { registerContract } from './validate'

export interface Payroll_CancelEmployeeAdvanceInput {}

registerContract('Payroll_CancelEmployeeAdvanceInput', {})
